module.exports = __webpack_public_path__ + "static/media/pointsPage.cb1c74ff.png";